module.exports = __webpack_public_path__ + "static/media/ArrowDown.f6775e05.svg";